import useSWR from 'swr';

export const usePlan = (planId) => {
  const { data, error, isLoading, mutate } = useSWR(
    planId ? `/plans/show/${planId}` : null,
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};

